import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    label: string;
    linkCopied: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for copy link button */
            label: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CopyLink.label?c=jk0x2liq2d58", defaultMessage: "Copy link" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success message when link is copied */
            linkCopied: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CopyLink.linkCopied?c=3q4glvafi7lns", defaultMessage: "Link copied!" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
